import { createSelector } from 'reselect';
import { leaderboardNavSelector } from './simple-selectors';

/**
 * @returns {( object ) => object|null} Compseason.
 */
export const compSeasonSelector = createSelector(
    leaderboardNavSelector,
    (state) => state.seasons,
    (nav, compSeasons) => {
        try {
            return compSeasons[`competition_${nav.competition.id}`][
                `season_${nav.season.id}`
            ];
        } catch (err) {
            return null;
        }
    }
);
